import { UserFormValues } from "../../Users/UserForm/types";

export const VENUE_USER_INITIAL_VALUES: UserFormValues<true> = {
  input: {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    role: null,
  },
};
